/** ManagedOps landing page copy (en / es / pt). Merged into LanguageContext. */
export const managedopsTranslations = {
  en: {
    'mops.seo.title': 'Alio ManagedOps | Managed Cloud, Security, AI, DevOps & QA Operations',
    'mops.seo.description':
      'Alio ManagedOps helps growing organizations operate, secure, and continuously improve cloud, software, AI agent programs, QA, and business-critical platforms.',
    'mops.hero.badge': 'Alio ManagedOps',
    'mops.hero.title1': 'Not Traditional IT Support.',
    'mops.hero.title2': 'Managed Engineering Operations.',
    'mops.hero.body1Before':
      'Alio ManagedOps gives your business a senior technical operations team for the systems that matter most: cloud infrastructure, CI/CD pipelines, cybersecurity, QA automation, Salesforce, Microsoft, data workflows, and AI-powered platforms—including ongoing ',
    'mops.hero.body1Bold': 'AI agent development',
    'mops.hero.body1After':
      ' as a managed service, so agent workflows, RAG, and integrations keep improving after launch instead of stalling in production.',
    'mops.hero.body2':
      'We help growing organizations operate, secure, and continuously improve critical technology without the cost and complexity of building a large in-house operations team.',
    'mops.hero.tagline': 'Secure, stable, continuously optimized.',
    'mops.hero.ctaAssessment': 'Schedule a ManagedOps Assessment',
    'mops.hero.ctaPlans': 'View Monthly Support Plans',
    'mops.hero.footer': 'Built by Alio IT with teams across the United States, Mexico, and India.',
    'mops.who.title': 'Who This Is For',
    'mops.who.intro':
      'Built for teams that have outgrown ad hoc support and need an ongoing technical operations partner.',
    'mops.who.item1': 'SaaS companies',
    'mops.who.item2': 'EdTech companies',
    'mops.who.item3': 'HealthTech companies',
    'mops.who.item4': 'Insurance and FinTech teams',
    'mops.who.item5': 'Higher education organizations',
    'mops.who.item6': 'Utilities, manufacturing, and logistics teams',
    'mops.areas.title': 'One Managed Team. Six Critical Operating Areas.',
    'mops.cloud.title': 'Managed Cloud & DevOps',
    'mops.cloud.item1': 'AWS, Azure, and GCP support',
    'mops.cloud.item2': 'CI/CD monitoring and optimization',
    'mops.cloud.item3': 'Infrastructure-as-code maintenance',
    'mops.cloud.item4': 'FinOps and cloud cost optimization',
    'mops.cloud.item5': 'Observability, alerting, and production support',
    'mops.cyber.title': 'Managed Cybersecurity & vCISO',
    'mops.cyber.item1': 'vCISO advisory and security assessments',
    'mops.cyber.item2': 'Compliance management and audit preparation',
    'mops.cyber.item3': 'Incident response planning',
    'mops.cyber.item4': 'Risk remediation tracking',
    'mops.cyber.item5': 'Vendor and third-party risk review',
    'mops.health.title': 'Managed HealthTech Security',
    'mops.health.item1': 'HIPAA risk assessments',
    'mops.health.item2': 'SOC 2 and HITRUST readiness',
    'mops.health.item3': 'PHI protection and incident planning',
    'mops.health.item4': 'Healthcare vendor risk management',
    'mops.health.item5': 'Security training and program design',
    'mops.qa.title': 'Managed QA Automation',
    'mops.qa.item1': 'Katalon, Selenium, and Cypress suite support',
    'mops.qa.item2': 'Regression maintenance and flaky-test reduction',
    'mops.qa.item3': 'Release readiness and CI test execution support',
    'mops.qa.item4': 'Test failure triage and QA dashboards',
    'mops.qa.item5': 'AI-assisted test generation with human QA review',
    'mops.aiDev.title': 'Managed AI Agent Development',
    'mops.aiDev.item1': 'Design and iteration of domain-specific agents, tools, and RAG pipelines',
    'mops.aiDev.item2': 'Ongoing build-out and refinement on a managed cadence—not a one-off project',
    'mops.aiDev.item3':
      'VirtualBoard-style AI-augmented engineering workflows with human-in-the-loop review',
    'mops.aiDev.item4': 'Evaluations, safety checks, and production tuning as your use cases evolve',
    'mops.aiDev.item5': 'Integration with support, CRM, internal wikis, and line-of-business systems',
    'mops.aiOps.title': 'Managed AI Operations',
    'mops.aiOps.item1': 'Day-to-day AI platform, model, and RAG workflow support',
    'mops.aiOps.item2': 'Prompt and workflow optimization in production',
    'mops.aiOps.item3': 'AI governance, policy, and risk review',
    'mops.aiOps.item4': 'Model and vendor evaluation, cost, and performance monitoring',
    'mops.aiOps.item5': 'Operational integrations with CRM, ERP, and internal platforms',
    'mops.compare.title': 'Traditional MSP vs Alio ManagedOps',
    'mops.compare.colTraditional': 'Traditional MSP',
    'mops.compare.colAlio': 'Alio ManagedOps',
    'mops.compare.row1a': 'Help desk support',
    'mops.compare.row1b': 'Engineering operations support',
    'mops.compare.row2a': 'Device management',
    'mops.compare.row2b': 'Cloud, DevOps, QA, AI, and security operations',
    'mops.compare.row3a': 'Reactive ticket handling',
    'mops.compare.row3b': 'Continuous improvement and optimization',
    'mops.compare.row4a': 'Per-user support pricing',
    'mops.compare.row4b': 'Outcome-based managed service retainers',
    'mops.plans.title': 'Monthly Support Plans',
    'mops.plans.essentials.name': 'ManagedOps Essentials',
    'mops.plans.essentials.price': '$3,500 - $7,000/month',
    'mops.plans.essentials.desc':
      'Includes monthly operations review, ticket-based technical support, cloud/security/QA backlog support, and monthly recommendations report.',
    'mops.plans.growth.name': 'ManagedOps Growth',
    'mops.plans.growth.price': '$7,500 - $14,000/month',
    'mops.plans.growth.desc':
      'Includes CI/CD deployment support, FinOps optimization, QA automation maintenance, and security remediation tracking with executive reviews.',
    'mops.plans.enterprise.name': 'ManagedOps Enterprise',
    'mops.plans.enterprise.price': '$15,000 - $30,000+/month',
    'mops.plans.enterprise.desc':
      'Includes end-to-end cloud, AI, QA, cybersecurity, and compliance operations with dedicated leadership and advanced incident support.',
    'mops.plans.disclaimer':
      'Final pricing depends on platform scope, support hours, compliance needs, and response SLAs.',
    'mops.proof.title': 'Proof Points',
    'mops.proof.intro':
      'Trusted across industries including SaaS, healthcare, education, insurance, and regulated platforms.',
    'mops.proof.item1': 'NinjaOne: QA automation at scale and stronger release confidence',
    'mops.proof.item2': 'Time4Learning: scalable cloud support for large EdTech workloads',
    'mops.proof.item3': 'USAHS: Salesforce/Core/Jenzabar platform alignment',
    'mops.proof.item4': 'Nerito: FinTech operations supporting 99.9% uptime goals',
    'mops.proof.ctaQuote': 'Get Exact Quote',
    'mops.proof.ctaCases': 'View Case Studies',
    'mops.films.badge': 'See the work',
    'mops.films.title': 'From a convincing demo to a system you can run.',
    'mops.films.intro':
      'One player, three industries. Each film is just over a minute: senior engineers inside the real workflow, through security, QA, and operations.',
    'mops.films.choose': 'Choose an industry film',
    'mops.films.play': 'Play',
    'mops.films.ai.title': 'AI & FinTech',
    'mops.films.ai.blurb': 'Agents, RAG, and financial workflows that stay governed after launch.',
    'mops.films.insure.title': 'InsurTech & EdTech',
    'mops.films.insure.blurb': 'Claims operations and student systems, with human review still in the loop.',
    'mops.films.cyber.title': 'Security & Cloud',
    'mops.films.cyber.blurb': 'HIPAA infrastructure, and one team across AWS, Azure, and GCP.',
  },
  es: {
    'mops.seo.title':
      'Alio ManagedOps | Operaciones gestionadas de nube, seguridad, IA, DevOps y QA',
    'mops.seo.description':
      'Alio ManagedOps ayuda a organizaciones en crecimiento a operar, proteger y mejorar de forma continua la nube, el software, los programas de agentes de IA, QA y plataformas críticas para el negocio.',
    'mops.hero.badge': 'Alio ManagedOps',
    'mops.hero.title1': 'No es soporte de TI tradicional.',
    'mops.hero.title2': 'Operaciones de ingeniería gestionadas.',
    'mops.hero.body1Before':
      'Alio ManagedOps brinda a su empresa un equipo senior de operaciones técnicas para los sistemas que más importan: infraestructura en la nube, pipelines de CI/CD, ciberseguridad, automatización de QA, Salesforce, Microsoft, flujos de datos y plataformas con IA—incluyendo de forma continua el ',
    'mops.hero.body1Bold': 'desarrollo de agentes de IA',
    'mops.hero.body1After':
      ' como servicio gestionado, para que los flujos de agentes, RAG e integraciones sigan mejorando después del lanzamiento en lugar de estancarse en producción.',
    'mops.hero.body2':
      'Ayudamos a organizaciones en crecimiento a operar, proteger y mejorar tecnología crítica sin el costo y la complejidad de construir un gran equipo de operaciones interno.',
    'mops.hero.tagline': 'Seguro, estable y optimizado de forma continua.',
    'mops.hero.ctaAssessment': 'Agendar una evaluación ManagedOps',
    'mops.hero.ctaPlans': 'Ver planes de soporte mensual',
    'mops.hero.footer': 'Desarrollado por Alio IT con equipos en Estados Unidos, México e India.',
    'mops.who.title': 'Para quién es',
    'mops.who.intro':
      'Diseñado para equipos que superaron el soporte ad hoc y necesitan un socio continuo de operaciones técnicas.',
    'mops.who.item1': 'Empresas SaaS',
    'mops.who.item2': 'Empresas EdTech',
    'mops.who.item3': 'Empresas HealthTech',
    'mops.who.item4': 'Equipos de seguros y FinTech',
    'mops.who.item5': 'Organizaciones de educación superior',
    'mops.who.item6': 'Equipos de servicios públicos, manufactura y logística',
    'mops.areas.title': 'Un solo equipo gestionado. Seis áreas críticas de operación.',
    'mops.cloud.title': 'Nube y DevOps gestionados',
    'mops.cloud.item1': 'Soporte en AWS, Azure y GCP',
    'mops.cloud.item2': 'Monitoreo y optimización de CI/CD',
    'mops.cloud.item3': 'Mantenimiento de infraestructura como código',
    'mops.cloud.item4': 'FinOps y optimización de costos en la nube',
    'mops.cloud.item5': 'Observabilidad, alertas y soporte en producción',
    'mops.cyber.title': 'Ciberseguridad y vCISO gestionados',
    'mops.cyber.item1': 'Asesoría vCISO y evaluaciones de seguridad',
    'mops.cyber.item2': 'Gestión de cumplimiento y preparación para auditorías',
    'mops.cyber.item3': 'Planificación de respuesta a incidentes',
    'mops.cyber.item4': 'Seguimiento de remediación de riesgos',
    'mops.cyber.item5': 'Revisión de riesgos de proveedores y terceros',
    'mops.health.title': 'Seguridad HealthTech gestionada',
    'mops.health.item1': 'Evaluaciones de riesgo HIPAA',
    'mops.health.item2': 'Preparación SOC 2 y HITRUST',
    'mops.health.item3': 'Protección de PHI y planificación de incidentes',
    'mops.health.item4': 'Gestión de riesgos de proveedores de salud',
    'mops.health.item5': 'Capacitación en seguridad y diseño de programas',
    'mops.qa.title': 'Automatización de QA gestionada',
    'mops.qa.item1': 'Soporte de suites Katalon, Selenium y Cypress',
    'mops.qa.item2': 'Mantenimiento de regresión y reducción de pruebas inestables',
    'mops.qa.item3': 'Preparación de releases y soporte de ejecución de pruebas en CI',
    'mops.qa.item4': 'Triaje de fallos de prueba y tableros de QA',
    'mops.qa.item5': 'Generación de pruebas asistida por IA con revisión humana de QA',
    'mops.aiDev.title': 'Desarrollo de agentes de IA gestionado',
    'mops.aiDev.item1': 'Diseño e iteración de agentes, herramientas y pipelines RAG específicos del dominio',
    'mops.aiDev.item2':
      'Construcción y refinamiento continuos con cadencia gestionada—no un proyecto único',
    'mops.aiDev.item3':
      'Flujos de ingeniería aumentados con IA estilo VirtualBoard y revisión humana en el ciclo',
    'mops.aiDev.item4':
      'Evaluaciones, controles de seguridad y ajuste en producción a medida que evolucionan los casos de uso',
    'mops.aiDev.item5': 'Integración con soporte, CRM, wikis internos y sistemas de negocio',
    'mops.aiOps.title': 'Operaciones de IA gestionadas',
    'mops.aiOps.item1': 'Soporte diario de plataformas de IA, modelos y flujos RAG',
    'mops.aiOps.item2': 'Optimización de prompts y flujos en producción',
    'mops.aiOps.item3': 'Gobernanza, políticas y revisión de riesgos de IA',
    'mops.aiOps.item4': 'Evaluación de modelos y proveedores, costos y monitoreo de rendimiento',
    'mops.aiOps.item5': 'Integraciones operativas con CRM, ERP y plataformas internas',
    'mops.compare.title': 'MSP tradicional vs Alio ManagedOps',
    'mops.compare.colTraditional': 'MSP tradicional',
    'mops.compare.colAlio': 'Alio ManagedOps',
    'mops.compare.row1a': 'Soporte de mesa de ayuda',
    'mops.compare.row1b': 'Soporte de operaciones de ingeniería',
    'mops.compare.row2a': 'Gestión de dispositivos',
    'mops.compare.row2b': 'Operaciones de nube, DevOps, QA, IA y seguridad',
    'mops.compare.row3a': 'Gestión reactiva de tickets',
    'mops.compare.row3b': 'Mejora continua y optimización',
    'mops.compare.row4a': 'Precio por usuario de soporte',
    'mops.compare.row4b': 'Retainers de servicios gestionados basados en resultados',
    'mops.plans.title': 'Planes de soporte mensual',
    'mops.plans.essentials.name': 'ManagedOps Essentials',
    'mops.plans.essentials.price': '$3,500 - $7,000/mes',
    'mops.plans.essentials.desc':
      'Incluye revisión mensual de operaciones, soporte técnico por tickets, backlog de nube/seguridad/QA e informe mensual de recomendaciones.',
    'mops.plans.growth.name': 'ManagedOps Growth',
    'mops.plans.growth.price': '$7,500 - $14,000/mes',
    'mops.plans.growth.desc':
      'Incluye soporte de despliegue CI/CD, optimización FinOps, mantenimiento de automatización de QA y seguimiento de remediación de seguridad con revisiones ejecutivas.',
    'mops.plans.enterprise.name': 'ManagedOps Enterprise',
    'mops.plans.enterprise.price': '$15,000 - $30,000+/mes',
    'mops.plans.enterprise.desc':
      'Incluye operaciones integrales de nube, IA, QA, ciberseguridad y cumplimiento con liderazgo dedicado y soporte avanzado ante incidentes.',
    'mops.plans.disclaimer':
      'El precio final depende del alcance de plataformas, horas de soporte, necesidades de cumplimiento y SLAs de respuesta.',
    'mops.proof.title': 'Resultados comprobados',
    'mops.proof.intro':
      'Confianza en industrias como SaaS, salud, educación, seguros y plataformas reguladas.',
    'mops.proof.item1': 'NinjaOne: automatización de QA a escala y mayor confianza en releases',
    'mops.proof.item2': 'Time4Learning: soporte en la nube escalable para cargas EdTech grandes',
    'mops.proof.item3': 'USAHS: alineación de plataformas Salesforce/Core/Jenzabar',
    'mops.proof.item4': 'Nerito: operaciones FinTech con objetivo de 99.9% de uptime',
    'mops.proof.ctaQuote': 'Obtener cotización exacta',
    'mops.proof.ctaCases': 'Ver casos de estudio',
    'mops.films.badge': 'Vea el trabajo',
    'mops.films.title': 'De un demo convincente a un sistema que se puede operar.',
    'mops.films.intro':
      'Un reproductor, tres industrias. Cada video dura poco más de un minuto: ingenieros senior dentro del flujo real, pasando por seguridad, QA y operaciones.',
    'mops.films.choose': 'Elija un video por industria',
    'mops.films.play': 'Reproducir',
    'mops.films.ai.title': 'IA y FinTech',
    'mops.films.ai.blurb': 'Agentes, RAG y flujos financieros que siguen gobernados después del lanzamiento.',
    'mops.films.insure.title': 'InsurTech y EdTech',
    'mops.films.insure.blurb': 'Operación de reclamos y sistemas estudiantiles, con revisión humana en el ciclo.',
    'mops.films.cyber.title': 'Seguridad y nube',
    'mops.films.cyber.blurb': 'Infraestructura HIPAA y un solo equipo en AWS, Azure y GCP.',
  },
  pt: {
    'mops.seo.title':
      'Alio ManagedOps | Operações gerenciadas de nuvem, segurança, IA, DevOps e QA',
    'mops.seo.description':
      'A Alio ManagedOps ajuda organizações em crescimento a operar, proteger e melhorar continuamente nuvem, software, programas de agentes de IA, QA e plataformas críticas para o negócio.',
    'mops.hero.badge': 'Alio ManagedOps',
    'mops.hero.title1': 'Não é suporte de TI tradicional.',
    'mops.hero.title2': 'Operações de engenharia gerenciadas.',
    'mops.hero.body1Before':
      'A Alio ManagedOps oferece à sua empresa uma equipe sênior de operações técnicas para os sistemas que mais importam: infraestrutura em nuvem, pipelines de CI/CD, cibersegurança, automação de QA, Salesforce, Microsoft, fluxos de dados e plataformas com IA—incluindo de forma contínua o ',
    'mops.hero.body1Bold': 'desenvolvimento de agentes de IA',
    'mops.hero.body1After':
      ' como serviço gerenciado, para que fluxos de agentes, RAG e integrações continuem evoluindo após o lançamento em vez de estagnar em produção.',
    'mops.hero.body2':
      'Ajudamos organizações em crescimento a operar, proteger e melhorar tecnologia crítica sem o custo e a complexidade de montar uma grande equipe interna de operações.',
    'mops.hero.tagline': 'Seguro, estável e otimizado continuamente.',
    'mops.hero.ctaAssessment': 'Agendar uma avaliação ManagedOps',
    'mops.hero.ctaPlans': 'Ver planos de suporte mensal',
    'mops.hero.footer': 'Desenvolvido pela Alio IT com equipes nos Estados Unidos, México e Índia.',
    'mops.who.title': 'Para quem é',
    'mops.who.intro':
      'Feito para equipes que superaram o suporte ad hoc e precisam de um parceiro contínuo de operações técnicas.',
    'mops.who.item1': 'Empresas SaaS',
    'mops.who.item2': 'Empresas EdTech',
    'mops.who.item3': 'Empresas HealthTech',
    'mops.who.item4': 'Equipes de seguros e FinTech',
    'mops.who.item5': 'Organizações de ensino superior',
    'mops.who.item6': 'Equipes de utilities, manufatura e logística',
    'mops.areas.title': 'Uma equipe gerenciada. Seis áreas críticas de operação.',
    'mops.cloud.title': 'Nuvem e DevOps gerenciados',
    'mops.cloud.item1': 'Suporte em AWS, Azure e GCP',
    'mops.cloud.item2': 'Monitoramento e otimização de CI/CD',
    'mops.cloud.item3': 'Manutenção de infraestrutura como código',
    'mops.cloud.item4': 'FinOps e otimização de custos na nuvem',
    'mops.cloud.item5': 'Observabilidade, alertas e suporte em produção',
    'mops.cyber.title': 'Cibersegurança e vCISO gerenciados',
    'mops.cyber.item1': 'Consultoria vCISO e avaliações de segurança',
    'mops.cyber.item2': 'Gestão de conformidade e preparação para auditorias',
    'mops.cyber.item3': 'Planejamento de resposta a incidentes',
    'mops.cyber.item4': 'Acompanhamento de remediação de riscos',
    'mops.cyber.item5': 'Revisão de riscos de fornecedores e terceiros',
    'mops.health.title': 'Segurança HealthTech gerenciada',
    'mops.health.item1': 'Avaliações de risco HIPAA',
    'mops.health.item2': 'Preparação SOC 2 e HITRUST',
    'mops.health.item3': 'Proteção de PHI e planejamento de incidentes',
    'mops.health.item4': 'Gestão de riscos de fornecedores de saúde',
    'mops.health.item5': 'Treinamento em segurança e desenho de programas',
    'mops.qa.title': 'Automação de QA gerenciada',
    'mops.qa.item1': 'Suporte a suites Katalon, Selenium e Cypress',
    'mops.qa.item2': 'Manutenção de regressão e redução de testes instáveis',
    'mops.qa.item3': 'Prontidão de release e suporte à execução de testes em CI',
    'mops.qa.item4': 'Triagem de falhas de teste e dashboards de QA',
    'mops.qa.item5': 'Geração de testes assistida por IA com revisão humana de QA',
    'mops.aiDev.title': 'Desenvolvimento de agentes de IA gerenciado',
    'mops.aiDev.item1': 'Design e iteração de agentes, ferramentas e pipelines RAG específicos do domínio',
    'mops.aiDev.item2':
      'Construção e refinamento contínuos em cadência gerenciada—não um projeto único',
    'mops.aiDev.item3':
      'Fluxos de engenharia aumentados com IA no estilo VirtualBoard e revisão humana no loop',
    'mops.aiDev.item4':
      'Avaliações, checagens de segurança e ajuste em produção conforme os casos de uso evoluem',
    'mops.aiDev.item5': 'Integração com suporte, CRM, wikis internos e sistemas de negócio',
    'mops.aiOps.title': 'Operações de IA gerenciadas',
    'mops.aiOps.item1': 'Suporte diário a plataformas de IA, modelos e fluxos RAG',
    'mops.aiOps.item2': 'Otimização de prompts e fluxos em produção',
    'mops.aiOps.item3': 'Governança, políticas e revisão de riscos de IA',
    'mops.aiOps.item4': 'Avaliação de modelos e fornecedores, custos e monitoramento de desempenho',
    'mops.aiOps.item5': 'Integrações operacionais com CRM, ERP e plataformas internas',
    'mops.compare.title': 'MSP tradicional vs Alio ManagedOps',
    'mops.compare.colTraditional': 'MSP tradicional',
    'mops.compare.colAlio': 'Alio ManagedOps',
    'mops.compare.row1a': 'Suporte de help desk',
    'mops.compare.row1b': 'Suporte de operações de engenharia',
    'mops.compare.row2a': 'Gestão de dispositivos',
    'mops.compare.row2b': 'Operações de nuvem, DevOps, QA, IA e segurança',
    'mops.compare.row3a': 'Tratamento reativo de tickets',
    'mops.compare.row3b': 'Melhoria contínua e otimização',
    'mops.compare.row4a': 'Preço por usuário de suporte',
    'mops.compare.row4b': 'Retainers de serviços gerenciados baseados em resultados',
    'mops.plans.title': 'Planos de suporte mensal',
    'mops.plans.essentials.name': 'ManagedOps Essentials',
    'mops.plans.essentials.price': '$3,500 - $7,000/mês',
    'mops.plans.essentials.desc':
      'Inclui revisão mensal de operações, suporte técnico por tickets, backlog de nuvem/segurança/QA e relatório mensal de recomendações.',
    'mops.plans.growth.name': 'ManagedOps Growth',
    'mops.plans.growth.price': '$7,500 - $14,000/mês',
    'mops.plans.growth.desc':
      'Inclui suporte a deploy CI/CD, otimização FinOps, manutenção de automação de QA e acompanhamento de remediação de segurança com revisões executivas.',
    'mops.plans.enterprise.name': 'ManagedOps Enterprise',
    'mops.plans.enterprise.price': '$15,000 - $30,000+/mês',
    'mops.plans.enterprise.desc':
      'Inclui operações ponta a ponta de nuvem, IA, QA, cibersegurança e conformidade com liderança dedicada e suporte avançado a incidentes.',
    'mops.plans.disclaimer':
      'O preço final depende do escopo de plataformas, horas de suporte, necessidades de conformidade e SLAs de resposta.',
    'mops.proof.title': 'Provas de valor',
    'mops.proof.intro':
      'Confiança em indústrias como SaaS, saúde, educação, seguros e plataformas reguladas.',
    'mops.proof.item1': 'NinjaOne: automação de QA em escala e maior confiança em releases',
    'mops.proof.item2': 'Time4Learning: suporte em nuvem escalável para cargas EdTech grandes',
    'mops.proof.item3': 'USAHS: alinhamento de plataformas Salesforce/Core/Jenzabar',
    'mops.proof.item4': 'Nerito: operações FinTech com meta de 99,9% de uptime',
    'mops.proof.ctaQuote': 'Obter cotação exata',
    'mops.proof.ctaCases': 'Ver estudos de caso',
    'mops.films.badge': 'Veja o trabalho',
    'mops.films.title': 'De um demo convincente a um sistema que dá para operar.',
    'mops.films.intro':
      'Um player, três indústrias. Cada filme dura pouco mais de um minuto: engenheiros seniores dentro do fluxo real, passando por segurança, QA e operações.',
    'mops.films.choose': 'Escolha um filme por indústria',
    'mops.films.play': 'Reproduzir',
    'mops.films.ai.title': 'IA e FinTech',
    'mops.films.ai.blurb': 'Agentes, RAG e fluxos financeiros que continuam governados depois do lançamento.',
    'mops.films.insure.title': 'InsurTech e EdTech',
    'mops.films.insure.blurb': 'Operação de sinistros e sistemas estudantis, com revisão humana no ciclo.',
    'mops.films.cyber.title': 'Segurança e nuvem',
    'mops.films.cyber.blurb': 'Infraestrutura HIPAA e um só time em AWS, Azure e GCP.',
  },
} as const;
